/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIRoleSubRole
 */
export interface APIRoleSubRole {
    /**
     * 
     * @type {string}
     * @memberof APIRoleSubRole
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIRoleSubRole
     */
    name: string;
}

/**
 * Check if a given object implements the APIRoleSubRole interface.
 */
export function instanceOfAPIRoleSubRole(value: object): value is APIRoleSubRole {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIRoleSubRoleFromJSON(json: any): APIRoleSubRole {
    return APIRoleSubRoleFromJSONTyped(json, false);
}

export function APIRoleSubRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRoleSubRole {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function APIRoleSubRoleToJSON(value?: APIRoleSubRole | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

